"use client";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Image from "next/image";
import SliderArrow from "@/components/SliderArrow";
import { IPageContent } from "@/types/pageContent.types";
import "./Scene3CardsSliderV15.scss";

type Scene3CardsSliderV15Props = {
  cardsData: IPageContent["ionTrackingDevicePageModel"]["ionTrackingDevicePage"]["ionTrackingDevice3dSectionHoriCards"];
  arrowSourceData: IPageContent["ionTrackingDevicePageModel"]["ionTrackingDevicePage"]["ionTrackingDeviceAppliedAcrossComplex"];
};

export default function Scene3CardsSliderV15({
  cardsData,
  arrowSourceData,
}: Scene3CardsSliderV15Props) {
  let arrows: { url: string; alt: string }[] = [];
  if (Array.isArray(arrowSourceData) && arrowSourceData.length > 0) {
    const lastItem = arrowSourceData[arrowSourceData.length - 1];
    if (
      lastItem.__typename === "GalleryRecord" &&
      Array.isArray(lastItem.gallery) &&
      lastItem.gallery.length >= 1
    ) {
      arrows = lastItem.gallery;
    }
  }

  const settings = {
    className: "center sceneThreeCardsSlider",
    centerMode: false,
    infinite: cardsData.length > 4,
    centerPadding: "10px",
    slidesToShow: 4,
    slidesToScroll: 1,
    speed: 500,
    arrows: cardsData.length > 4,
    nextArrow: (
      <SliderArrow
        direction="next"
        imageUrl={arrows[arrows.length > 1 ? 1 : 0]?.url}
        imageAlt={arrows[arrows.length > 1 ? 1 : 0]?.alt}
      />
    ),
    prevArrow: (
      <SliderArrow
        direction="prev"
        imageUrl={arrows[0]?.url}
        imageAlt={arrows[0]?.alt}
        rotatePrev={arrows.length === 1}
      />
    ),
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 375,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="scene3CardsSliderV15">
      <Slider {...settings}>
        {cardsData.map((card, index) => {
          const cardImage =
            card.__typename === "HeadingGalleryRecord"
              ? card.gallery?.[0]
              : undefined;

          return (
            <div key={`scene3-${index}`} className="card sceneThreeCard">
              <div className="sceneThreeCardInner">
                {cardImage ? (
                  <Image src={cardImage.url} alt={cardImage.alt} width={50} height={50} />
                ) : null}
                <h3>{card.heading}</h3>
              </div>
            </div>
          );
        })}
      </Slider>
    </div>
  );
}
